import { useCallback, FC } from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'
import { FacebookShareButton } from 'react-share'
import { makeStyles, Theme } from '@material-ui/core/styles'
import clsx from 'clsx'
import styled from 'styled-components'
import CloseIcon from 'svgIcons/Close'
import { WideInfoModalContainer } from '.'
import { KakaoShareButton, KakaoShareButtonProps } from './KakaoShareButton'

const FacebookButton = styled((props) => <FacebookShareButton {...props} />)`
  flex: 1;
  height: 80px;
  background-image: url(/static/images/activity/share-facebook.png);
  background-size: 60px 60px;
  background-position: top center;
  background-repeat: no-repeat;
  text-align: center;
  cursor: pointer;
`

const useStyles = makeStyles((theme: Theme) => {
  return {
    root: {
      margin: 'auto',
      wdith: 'calc(100% - 32px)',
      maxWidth: 350,
      borderRadius: '4px',
      backgroundColor: '#ffffff',
      position: 'relative',
      marginTop: 15,
      padding: 0,
    },
    header: {
      display: 'flex',
      flexGrow: 1,
      justifyContent: 'space-between',
      height: 64,
      backgroundColor: '#002f56',
      borderRadius: '2px 2px 0 0',
      padding: '18px 24px',
      color: '#ffffff',
    },
    title: {
      fontSize: '1.4rem',
      fontWeight: 500,
      color: '#ffffff',
    },
    svgIcon: {
      cursor: 'pointer',
    },
    body: {
      padding: '32px 24px',
    },
    buttonsWrapper: {
      display: 'flex',
    },
    iconButtonBase: {
      flex: 1,
      height: 80,
      backgroundSize: '60px 60px',
      backgroundPosition: 'top center',
      backgroundRepeat: 'no-repeat',
      textAlign: 'center',
      cursor: 'pointer',
    },
    facebook: {
      backgroundImage: 'url(/static/images/activity/share-facebook.png)',
    },
    naver: {
      backgroundImage: 'url(/static/images/activity/share-naver.png)',
    },
    kakao: {
      backgroundImage: 'url(/static/images/activity/share-kakao.png)',
    },
    linkBoxWrapper: {
      position: 'relative',
      width: '100%',
      marginTop: 10,
      padding: '0 10px',
    },
    linkBox: {
      width: '100%',
      height: 'auto',
      padding: '10px 40px 10px 8px',
      border: '1px solid #cddae3',
      borderRadius: 2,
      backgroundColor: '#e6ecf0',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    copyButton: {
      position: 'absolute',
      top: 7,
      right: 18,
      width: 30,
      color: theme.palette.primary.main,
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  }
})

interface ShareModalProps {
  title?: string
  open: boolean
  url: string
  quote: string
  kakaoShareProps?: Omit<KakaoShareButtonProps, 'title'>
  onModalClose?: () => void
}

const ShareModal: FC<ShareModalProps> = ({
  title = '링크 공유',
  open,
  onModalClose,
  url,
  quote,
  kakaoShareProps,
}) => {
  const classes = useStyles()
  const handleNaverShareButtonClick = useCallback(() => {
    const url = window.location.href
    const label = `[링커리어] ${quote}`
    const shareURL = `http://share.naver.com/web/shareView.nhn?url=${encodeURI(
      url,
    )}&title=${encodeURI(label)}`

    window.open(shareURL)
  }, [quote])

  return (
    <WideInfoModalContainer isOpen={open} onRequestClose={onModalClose}>
      <div className={classes.root}>
        <div className={classes.header}>
          <div className={classes.title}>{title}</div>
          <CloseIcon onClick={onModalClose} className={classes.svgIcon} />
        </div>
        <div className={classes.body}>
          <div className={classes.buttonsWrapper}>
            <FacebookButton url={url} quote={quote} />
            <div
              onClick={handleNaverShareButtonClick}
              className={clsx(classes.iconButtonBase, classes.naver)}
            />
            <div className={clsx(classes.iconButtonBase, classes.kakao)}>
              <KakaoShareButton {...kakaoShareProps} title={quote} />
            </div>
          </div>
          <div className={classes.linkBoxWrapper}>
            <input
              type="textbox"
              value={url}
              className={classes.linkBox}
              readOnly
            />
            <CopyToClipboard text={url}>
              <span className={classes.copyButton}>복사</span>
            </CopyToClipboard>
          </div>
        </div>
      </div>
    </WideInfoModalContainer>
  )
}

export default ShareModal
